import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  class: "w-full h-full",
  viewBox: "0 0 31 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.667",
      d: "m11.75 13.125 2.5 2.5L19.875 10M25.5 26.25V9.75c0-2.1 0-3.15-.409-3.952a3.75 3.75 0 0 0-1.639-1.64C22.65 3.75 21.6 3.75 19.5 3.75h-8c-2.1 0-3.15 0-3.952.409a3.75 3.75 0 0 0-1.64 1.639C5.5 6.6 5.5 7.65 5.5 9.75v16.5l3.438-2.5 3.124 2.5 3.438-2.5 3.438 2.5 3.125-2.5z"
    }, null, -1)
  ])))
}
export default { render: render }